// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1Mp81","buttons":"PendingPaymentAlert_buttons__2lY6a"};